<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-start">
    <div class="container max-w-screen-lg mx-auto">
      <div>
        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>
            </div>

            <div id="form-fields" class="lg:col-span-2">
              <div
                class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
              >
                <!-- sector name -->
                <div class="md:col-span-5">
                  <BaseInput
                    type="text"
                    name="sectorForm.name"
                    v-model="store.sectorForm.name"
                    :info="'Setor'"
                    label="Nome do setor"
                    :required-field="true"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.sectorForm.name = undefined"
                      />
                    </template>
                  </BaseInput>

                  <span name="sectorForm.name" class="text-red-600 text-sm" />
                </div>

                <div class="md:col-span-5">
                  <div
                    class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-2"
                  >
                    <!-- participantes -->
                    <div class="md:col-span-1">
                      <BaseInput
                        type="text"
                        name="sectorForm.participantes"
                        v-model="store.sectorForm.participantes"
                        :info="'Participante'"
                        label="Nome do participante"
                        :required-field="true"
                        :activeDefault="false"
                      >
                        <template #append>
                          <CleanInputButton
                            @click="store.sectorForm.participantes = undefined"
                          />
                        </template>
                      </BaseInput>

                      <span
                        name="sectorForm.participantes"
                        class="text-red-600 text-sm"
                      />
                    </div>

                    <!-- emails -->
                    <div class="md:col-span-1">
                      <div class="grid gap-4 gap-y-2 text-sm grid-cols-5">
                        <!-- email -->
                        <div class="col-span-4">
                          <BaseInput
                            type="email"
                            name="sectorForm.email"
                            v-model="store.sectorForm.email"
                            :info="'Email'"
                            label="Email do participante"
                            :required-field="true"
                            :activeDefault="false"
                          >
                            <template #append>
                              <CleanInputButton
                                @click="store.sectorForm.email = undefined"
                              />
                            </template>
                          </BaseInput>

                          <span
                            name="sectorForm.email"
                            class="text-red-600 text-sm"
                          />
                        </div>

                        <!-- Botão de Adicionar -->
                        <div class="col-span-1">
                          <div class="h-full">
                            <button
                              @click="addIntegrante"
                              title="Adicionar integrante"
                              class="px-2 py-2 bg-gradient-to-r to-[#93cd24] from-[#0c7036] mt-3 text-white rounded-full hover:cursor-pointer transition-all hover:scale-105 text-center flex justify-center"
                            >
                              <component
                                class="w-8 h-8"
                                :is="PhUserPlus"
                              ></component>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Lista de Integrantes -->
                  <div
                    v-if="store.sectorForm.integrantes?.length"
                    class="mt-3 w-full max-h-[20vh] overflow-auto"
                  >
                    <h3
                      class="text-lg font-semibold text-start sticky top-0 bg-white p-1"
                    >
                      Integrantes Adicionados:
                    </h3>
                    <ul class="flex flex-wrap">
                      <li
                        v-for="(integrante, index) in store.sectorForm
                          .integrantes"
                        :key="index"
                        class="flex justify-between bg-gray-100 p-2 rounded-md m-1"
                      >
                        <label>
                          {{ integrante.nome }} <br />
                          <small>
                            {{ integrante.email }}
                          </small>
                        </label>
                        <button
                          @click="removeIntegrante(index)"
                          class="text-red-500 hover:text-red-700 flex px-1"
                        >
                          <component
                            :is="PhX"
                            class="w-5 h-5 rounded-full bg-white p-0.5"
                          ></component>
                        </button>
                      </li>
                    </ul>
                  </div>
                  <span
                    name="sectorForm.integrantes"
                    class="text-red-600 text-sm"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-center mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelect from "@/components/Select/SimpleSelect.vue";
import CleanInputButton from "../utils/CleanInputButton.vue";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import {
  PhCloudArrowUp,
  PhFileArrowUp,
  PhUserPlus,
  PhX,
} from "@phosphor-icons/vue";
import { docType } from "../lookups/form";
import { dataRcd } from "../store";

export default {
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
  },
  props: {
    descriptionTitle: String,
  },
  data() {
    return {
      PhFileArrowUp,
      PhCloudArrowUp,
      PhUserPlus,
      PhX,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      store: dataRcd.state,
      dataRcd,
      docType,
    };
  },
  methods: {
    addIntegrante() {
      const nome = this.store.sectorForm.participantes?.trim();
      const email = this.store.sectorForm.email?.trim();

      if (!nome || !email) {
        alert("Preencha ambos os campos antes de adicionar.");
        return;
      }

      this.store.sectorForm.integrantes.push({
        nome,
        email,
      });

      // Limpa os campos
      this.store.sectorForm.participantes = "";
      this.store.sectorForm.email = "";
    },
    removeIntegrante(index) {
      this.store.sectorForm.integrantes.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
